export default "__VITE_ASSET__B0iChs7M__"